
import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useLocation, matchPath } from "react-router-dom";
import "./assets/Navbar.css";
import vector from "./assets/Images/Vector.png";
import { FaSearch, FaBell, FaCalendarAlt, FaCog } from "react-icons/fa";
import Profile from "./assets/Images/profile.jpg";
import images from "./assets/Images/Solitaire-logo.png";
import logo from "./assets/Images/logo.jpg";

import { getSocket } from "./socket/socket";

import UniversalNotifications from './components/UniversalNotifications';
import SettingsList from './Settings/SettingsList';

function Navbar({ toggleSidebar }) {
  const [imgError, setImgError] = useState(false);
  // const showFallback = !user?.profileImage || imgError;

  const barRef = useRef();
  const { user } = useSelector((state) => state.auth);
  const showFallback = !user?.profileImage || imgError;
  const [searchVisible, setSearchVisible] = useState(false);
  const [settingsVisible, setSettingsVisible] = useState(false);
  const location = useLocation();
  console.log(user)
  const toggleSearch = () => {
    setSearchVisible(!searchVisible);
  };

  const toggleSettings = () => {
    setSettingsVisible(!settingsVisible);
  };

  useEffect(() => {
    const socket = getSocket();
    if (!socket) {
      console.log('socket is null')
      return;
    }

    socket.on("receiveMessage", () => {
      console.log("navbar reccive messgae", barRef)
      if (barRef.current) {
        console.log("navbar reccive messgae from inside")
        barRef.current.classList.add("highlighted");

        // Remove the effect after 3 seconds (or however long you want)
        setTimeout(() => {
          barRef.current.classList.remove("highlighted");
        }, 3000);
      }
    });

    return () => socket.off("receiveMessage"); // Cleanup
  }, []);

  // const getActivePage = () => {
  //   const path = location.pathname;
  //   console.log(path,"this is path")
  //   if (path.includes("/")) {
  //     if (path.includes("task")) return "TASK";
  //     if (path.includes("meeting")) return "MEETINGS";
  //     if (path.includes("orders")) return "ORDERS";
  //     if (path.includes("leads")) return "LEADS";
  //     if (path.includes("QuotationHeader")) return "Quotation";
  //     if (path.includes("VendorDatabase")) return "Vendor database";
  //     if (path.includes("MaterialCode")) return "Material Database";
  //     if (path.includes("database")) return "DATABASE";
  //     if (path.includes("contact")) return "CONTACT";
  //     if (path.includes("account")) return "ACCOUNT";
  //     if (path.includes("help")) return "HELP";
  //     if (path.includes("about")) return "ABOUT ME";
  //     if (path.includes("message")) return "message";
  //     if (path.includes("Estimations")) return "ESTIMATION";
  //     if (path.includes("chatapp")) return "MESSANGER";
  //     // Specific Follow Up pages
  //     if (path.includes("FollowUpBuying")) return "FOLLOW UP - Buying";
  //     if (path.includes("FollowUpBiddingBudgetary")) return "FOLLOW UP - Bidding/Budgetary";
  //     // Generic fallback for any other FollowUp routes
  //     if (path.includes("FollowUp")) return "FOLLOW UP";
  //     if (path.includes("ColdCalling")) return "LOST LEAD COLD CALLING";
  //     if (path.includes("CurrentCustomerColdCalling")) return "CURRENT CUSTOMER COLD CALLING";
  //     if (path.includes("TargetCustomerColdCalling")) return "TARGET CUSTOMER COLD CALLING";
  //     if (path.includes("CurrentCustomer")) return "CURRENT CUSTOMER DATABASE";
  //     if (path.includes("TargetCustomer")) return "TARGET CUSTOMER DATABASE";
  //     if (path.includes("targetcompany")) return "Target Customer Details";
  //     if (path.includes("company")) return "Current Customer Details";
  //     if (path.includes("vendor")) return "Vendor Database Details";
  //   }
  //   return "DASHBOARD";
  // };


  const getActivePage = () => {
    const path = location.pathname;
    console.log(path, "this is path");

    if (path.includes("/")) {
      // Email marketing specific routes
      if (matchPath("/email-marketing/campaigns/:campaignId", path)) return "📧 CAMPAIGN PROFILE";
      if (path.includes("email-marketing/campaigns")) return "📧 EMAIL MARKETING";
      if (path.includes("email-marketing/templates")) return "📧 EMAIL MARKETING";
      if (path.includes("email-marketing/subscribers")) return "📧 EMAIL MARKETING";
      if (path.includes("email-marketing")) return "📧 EMAIL MARKETING";

      // Specific routes first (most specific to least specific)
      if (path.includes("AI_test")) return "🤖 AI TEST";
      if (path.includes("Promote")) return "🚀 PROMOTE";
      if (path.includes("CurrentCustomerColdCalling")) return "📞 CURRENT CUSTOMER COLD CALLING";
      if (path.includes("TargetCustomerColdCalling")) return "🎯 TARGET CUSTOMER COLD CALLING";
      if (path.includes("ColdCalling")) return "☎️ LOST LEAD COLD CALLING";

      // Other specific routes
      if (path.includes("FollowUpOrder")) return "📦 ORDER FOLLOW UP";
      if (path.includes("FollowUpBuying")) return "🛍️ FOLLOW UP - BUYING";
      if (path.includes("FollowUpBiddingBudgetary")) return "💼 FOLLOW UP - BIDDING/BUDGETARY";

      // General routes
      if (path.includes("task")) return "📝 TASK";
      if (path.includes("meeting")) return "🤝 MEETINGS";
      if (path.includes("orders")) return "🛒 ORDERS";
      if (path.includes("leads")) return "🪪 LEADS";
      if (path.includes("QuotationHeader")) return "🪙 QUOTATION";
      if (path.includes("VendorDatabase")) return "🗄️ VENDOR DATABASE";
      if (path.includes("MaterialCode")) return "🏗️ MATERIAL DATABASE";
      if (path.includes("database")) return "📁 DATABASE";
      if (path.includes("contact")) return "👤 CONTACT";
      if (path.includes("account")) return "💳 ACCOUNT";
      if (path.includes("help")) return "🎫 HELP";
      if (path.includes("about")) return "ℹ️ ABOUT ME";
      if (path.includes("message")) return "💬 MESSAGE";
      if (path.includes("Estimations")) return "🧮 ESTIMATION";
      if (path.includes("chatapp")) return "💬 MESSENGER";
      if (path.includes("FollowUp")) return "⏳ FOLLOW UP";

      if (path.includes("CurrentCustomer")) return "👥 CURRENT CUSTOMER DATABASE";
      if (path.includes("TargetCustomer")) return "🎯 TARGET CUSTOMER DATABASE";
      if (path.includes("targetcompany")) return "🎯 TARGET CUSTOMER DETAILS";
      if (path.includes("NotInterested")) return "🚫 NOT INTERESTED";
      if (path.includes("company")) return "👥 CURRENT CUSTOMER DETAILS";
      if (path.includes("vendor")) return "🗄️ VENDOR DATABASE DETAILS";
      if (path.includes("DeletedVendor")) return "🗑️ DELETED VENDOR DATABASE";
      if (path.includes("sol-office-database")) return "🏢 SOL DATABASE";
    }
    return "📊 DASHBOARD";
  };

  return (
    <div ref={barRef} className="navbar bar">
      {/* Fixed Menu Button */}
      <button className="menu-button fixed-menu" onClick={toggleSidebar}>
        ☰
      </button>
      {/* Logo */}
      {/* <img className="ImagesSolitaire" src={user.profileImage} alt="Solitaire Logo" /> */}
      {/* Dashboard Title */}
      <div className="dashboard-container">
        <div className="Dashboard">{getActivePage()}</div>
        <div>
          <span className="UserName">
            Welcome, {user?.firstName || "User"} {user?.lastName || ""}
          </span>
        </div>
      </div>
      {/* User Icons */}
      <div className="user-section">
        {/* Sleek Expanding Search Bar */}
        <div className={`search-container-premium ${searchVisible ? "expanded" : ""}`}>
          <div className="search-icon-btn" onClick={toggleSearch}>
            <FaSearch size={20} color="#525252" />
          </div>
          <input
            className="input-search-premium"
            type="text"
            placeholder="Search..."
          />
        </div>

        <div className="nav-icon-wrapper">
          <UniversalNotifications />
        </div>

        <div className="nav-icon-wrapper">
          <div className="nav-icon-btn">
            <FaCalendarAlt size={22} color="#525252" />
          </div>
        </div>

        {/* Settings dropdown */}
        <div style={{ position: 'relative' }} className="nav-icon-wrapper">
          <div className="nav-icon-btn" onClick={toggleSettings}>
            <FaCog size={22} color="#525252" />
          </div>
          <SettingsList
            isVisible={settingsVisible}
            onClose={() => setSettingsVisible(false)}
          />
        </div>

        <div className="nav-icon-wrapper">
          <img src={showFallback ? logo : user.profileImage} alt="User" className="user-icon-premium" />
        </div>
      </div>
    </div>
  );
}

export default Navbar;
